module.exports = __webpack_public_path__ + "img/britta-ebenberger.1e696a0f.jpg";